import { IJsonQuery } from '../../../types/interfaces';
import { IApplicationState } from '../../../types/redux';

export const getCurrentJsonQuery = (state: IApplicationState): IJsonQuery => {
  return state.location.jsonQuery;
};
